import { render, staticRenderFns } from "./TheMenuOverlay.vue?vue&type=template&id=159038c8"
import script from "./TheMenuOverlay.vue?vue&type=script&lang=js"
export * from "./TheMenuOverlay.vue?vue&type=script&lang=js"
import style0 from "./TheMenuOverlay.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavSublinked: require('/vercel/path0/components/Nav/NavSublinked.vue').default,SocialButtons: require('/vercel/path0/components/SocialButtons/SocialButtons.vue').default})
